import axios from 'axios';
import { getFullUrl } from '@/helpers';

export const httpWithLoader = axios.create({
    // baseURL: 'http://192.168.88.22/api'
    //baseURL: 'http://ork.nark.suhanov.w.ibrush.ru/api',
    baseURL: getFullUrl('api/'),
    // baseURL: 'http://localhost/api',
    headers: {
        'Content-type': 'application/json'
    }
});

export const http = axios.create({
    // baseURL: 'http://192.168.88.22/api'
    //baseURL: 'http://ork.nark.suhanov.w.ibrush.ru/api',
    baseURL: getFullUrl('api/'),
    // baseURL: 'http://localhost/api',
    headers: {
        'Content-type': 'application/json'
    }
});